import { noteApiListNotificationsSinceLastQueryPOST } from "../notifications/notificationsApi"

import { LogError } from "../../helpers/logger"

import styles from "../../styles/dailyPlanner/DailyPlannerNotifications.module.css"

import {
  anyNotificationHasTags,
  notificationHasTags,
  replaceNotificationTags,
} from "../notifications/notificationsTags"

export function getNotifications(
  user,
  onSetNewNotifications,
  getNotificationUsers,
  checkNotificationUsers
) {
  noteApiListNotificationsSinceLastQueryPOST(user, 1, 100)
    .then(async (result) => {
      if (anyNotificationHasTags(result.items)) {
        const useSearchResult = await getNotificationUsers()
        let participantList = useSearchResult.data.participants || []
        let staffList = useSearchResult.data.staff || []

        //search for participants if not in the list
        for (let item in result.items) {
          if (notificationHasTags(result.items[item])) {
            participantList = await checkNotificationUsers(
              result.items[item],
              participantList
            )
          }
        }

        result.items = await Promise.all(
          result.items.map(async (notification) =>
            notificationHasTags(notification)
              ? await replaceNotificationTags(
                  notification,
                  participantList,
                  undefined,
                  undefined,
                  staffList,
                  undefined
                )
              : notification
          )
        )
      }

      onSetNewNotifications(result.items)
    })
    .catch((error) => {
      LogError("An unexpected error occurred while retrieving tasks", error)
      user.setNotificationError(error.Message)
    })
}

export function GetNewNotificationsPanel(notification) {
  return (
    <div className={styles.gridContainer}>
      <div className={styles.gridItemTitle}>
        <span className={styles.notificationHeader}>Title: </span>{" "}
        {notification.title}
      </div>
      <div className={styles.gridItemDescription}>
        <span className={styles.notificationHeader}>Body: </span>{" "}
        {notification.description}
      </div>
    </div>
  )
}

export function notificationHeaderButtonAction(user) {
  user.setNotificationAction({ actionUrl: "#ShowNotifications" })
}
